import React from 'react';
import { css } from '@tanium/react-emotion';
import { EmptyState } from '@tanium/react-empty-state';
import { StateCriticalIcon } from '@tanium/react-graphics';
import { COLUMN_HEADER_HEIGHT } from '../../constants';
import { useTranslation } from '../../localization';

const fullHeightClass = css({
  height: `calc(100% - ${COLUMN_HEADER_HEIGHT}px)`,
});

export const ErrorState = () => {
  const { t } = useTranslation();

  return (
    <EmptyState className={fullHeightClass} icon={StateCriticalIcon}>
      {t('Unable to load data')}
    </EmptyState>
  );
};
